<div class="copy-right-top text-center">
  <p class="copy-right py-4 mx-4 cursor-pointer" style="display: inline-block;">
    <a (click)="goPolicy()"> Aviso de privacidad</a>
  </p>
  <p class="copy-right py-4 mx-4 cursor-pointer" style="display: inline-block;">
    <a (click)="goTerms()"> Términos y Condiciones</a>
  </p>
</div>
  
<!-- copyright -->
<div class="copy-right-top">
  <ng-container *ngIf="!station; else showNameApi">
    <p class="copy-right text-center py-4">&copy; {{ currentYear }} {{ stationName }}. Todos los derechos registrados <br> Creada por <a href="https://iannes.com/" target="_blank"> Iannes </a></p>
  </ng-container>
  <ng-template #showNameApi>
    <p class="copy-right text-center py-4">&copy; {{ currentYear }} {{ station.nombre }}. Todos los derechos registrados <br> Creada por <a href="https://iannes.com/" target="_blank"> Iannes </a></p>
  </ng-template>
</div>
